var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"main-bread",attrs:{"separator-class":"el-icon-arrow-right"}},[(_vm.name2)?_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.name2))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }